import moment from 'moment';
import angular from 'angular';
import template from './series-chart.component.html';

class ChartController {
  constructor(gettextCatalog, $filter, $q, $timeout) {
    'ngInject';

    this.gettextCatalog = gettextCatalog;
    this.$filter = $filter;
    this.VALUE_DELIMETER = '#';
    this.CHART_DIV_ID = 'chart_div';
    this.colorArray = [
      '#67b7dc',
      '#fdd400',
      '#84b761',
      '#cc4748',
      '#cd82ad',
      '#2f4074',
      '#448e4d',
      '#b7b83f',
      '#b9783f',
      '#b93e3d',
      '#913167',
      '#666',
      '#777'
    ];
    this.descriptiveColorArray = ['#bbafff', '#ffea84', '#34495e'];
    this.aggregatedDataColorMap = {
      min: '#d35400',
      mean: '#f39c12',
      max: '#27ae60',
      delta: '#2c3e50'
    };
    this.BALLOON_COLOR = '#ffffff';
    this.requestedFunctions = ['mean', 'min', 'max', 'last', 'first', 'count', 'delta'];
    this.stockChart = null;
    this.chartDiv = null;
    this.balloonFunction = this.balloonFunction.bind(this);
    this.$q = $q;
    this.$timeout = $timeout;
  }

  $onInit() { }
  $onDestroy() {
    this.stockChart = null;
    this.updateChartDivHeight();
  }
  $onChanges(changes) {
    const { seriesData, startRange, endRange } = changes;
    if (
      seriesData &&
      Array.isArray(seriesData.currentValue) &&
      JSON.stringify(seriesData.currentValue) !== JSON.stringify(seriesData.previousValue)
    ) {
      if (seriesData.currentValue.length) {
        this.createOrUpdateChart();
      } else {
        this.stockChart = null;
        this.updateChartDivHeight();
      }
    }
    //in case the result (seriesData) will not change from previous we still need to update chart date
    if ((startRange && startRange.currentValue) || (endRange && endRange.currentValue)) {
      this.updateChartStartAndEndDate();
    }
  }
  getIntervalColor() {
    return '#7f8c8d';
  }
  getDescriptiveColor(valueIndex) {
    return this.descriptiveColorArray[Math.round(valueIndex) % this.descriptiveColorArray.length];
  }

  createOrUpdateChartAsync() {
    return this.$q((resolve, reject) => {
      try {
        //convert series t to user date object
        const data = this.seriesData.map(ser => {
          const modifiedData = (ser.data || []).map(record => ({ ...record, t: moment(record.t).toDate() }));
          return { ...ser, data: modifiedData };
        });
        let { dataset, panel } = this.createChartDataset(data);
        if (!this.stockChart) {
          this.stockChart = this.creatAmStockCharts(dataset, panel);
          if (this.chartDiv) {
            this.stockChart.write(this.CHART_DIV_ID);
          }
          this.stockChart.zoom(this.startRange, this.endRange);
        } else {
          this.stockChart.mainDataSet.dataProvider = dataset.dataProvider;
          this.stockChart.mainDataSet.fieldMappings = dataset.fieldMappings;
          this.stockChart.panels = panel;
          this.stockChart.zoom(this.startRange, this.endRange);

          this.stockChart.validateNow();
          this.stockChart.validateData();
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }
  createOrUpdateChart() {
    this.error = false;
    this.chartUpdating = true;
    //using timeout to force ui update
    this.$timeout(
      () => {
        this.updateChartDivHeight(this.seriesData.length);
        this.createOrUpdateChartAsync()
          .then()
          .catch(e => {
            this.error = true;
            console.error(e);
          })
          .finally(() => {
            this.chartUpdating = false;
          });
      },
      0,
      false
    );
  }
  updateChartStartAndEndDate() {
    try {
      if (this.stockChart) {
        this.chartZooming = true;
        this.stockChart.zoom(this.startRange, this.endRange);
      }
    } catch (e) {
      this.chartZooming = false;
      console.error(e);
    }
  }

  updateChartDivHeight(numberOfCharts = 1) {
    //empty parent div to display charts in sequence
    this.chartDiv = angular.element(`#${this.CHART_DIV_ID}`);
    this.chartDiv.empty();
    //calculate the height based on datapoint selection
    let height = 175 * numberOfCharts;
    height = height < 200 ? '200px' : `${height}px`;
    this.chartDiv.css('height', height);
  }

  creatAmStockCharts(stockChartDataset, stockPanel) {
    if (!stockChartDataset) return;

    //Don't need to render charts twice
    if (stockChart) return;
    AmCharts.baseHref = true;
    let stockParams = {};
    stockParams['fontFamily'] = 'Open Sans';

    const stockChart = new AmCharts.AmStockChart(stockParams);
    stockChart.path = 'https://cdn.amcharts.com/lib/3/';

    stockChart.type = 'stock';
    stockChart.theme = 'light';

    stockChart.dataSets = [stockChartDataset];
    stockChart.panels = stockPanel;

    //Chart Axis setting
    let categoryAxesSettings = new AmCharts.CategoryAxesSettings(); // x-axis
    categoryAxesSettings.minPeriod = 'fff';
    categoryAxesSettings.maxSeries = 0;

    stockChart.categoryAxesSettings = categoryAxesSettings;

    let valueAxesSettings = new AmCharts.ValueAxesSettings(); // y-axis
    valueAxesSettings.inside = false;
    stockChart.valueAxesSettings = valueAxesSettings;

    //scroll bar setting
    let chartScrollbarSettings = new AmCharts.ChartScrollbarSettings();
    chartScrollbarSettings.dragIcon = 'dragIconRectSmall';
    chartScrollbarSettings.dragIconHeight = 15;
    chartScrollbarSettings.dragIconWidth = 15;
    chartScrollbarSettings.color = '#000';
    chartScrollbarSettings.position = 'top';
    stockChart.chartScrollbarSettings = chartScrollbarSettings;

    //chart cursor setting
    let chartCursorSettings = new AmCharts.ChartCursorSettings();
    chartCursorSettings.cursorColor = '#1E90FF';
    chartCursorSettings.valueBalloonsEnabled = true;
    stockChart.chartCursorSettings = chartCursorSettings;

    //pannel setting for stock chart
    let panelsSettings = new AmCharts.PanelsSettings();
    panelsSettings.marginLeft = 80;
    panelsSettings.marginBottom = 10;
    panelsSettings.marginRight = 50;
    stockChart.panelsSettings = panelsSettings;

    //export button on the charts
    stockChart.export = {
      enabled: true,
      position: 'top-left',
      fileName: 'Asset-Detail-Charts',
      menu: [
        {
          class: 'export-main',
          menu: [
            {
              label: this.gettextCatalog.getString('Download'),
              menu: ['PNG', 'JPG', 'PDF', 'PRINT']
            },
            {
              label: this.gettextCatalog.getString('Annotate'),
              action: 'draw',
              menu: [
                {
                  class: 'export-drawing',
                  menu: ['PNG', 'JPG', 'PDF', 'PRINT', 'CANCEL']
                }
              ]
            }
          ]
        }
      ]
    };
    stockChart.initHC = false;
    //handle zooming
    stockChart.addListener('zoomed', event => {
      //disable zoomed in case we are updating chart data or we trigger zoom to update the end or start date
      if (this.chartUpdating || this.chartZooming) {
        //we are here means zoom done
        this.chartZooming = false;
        return;
      }

      const eventStartDate = moment(event.startDate).startOf('minute');
      const eventEndDate = moment(event.endDate).startOf('minute');

      //find the diffrence between event zoomd dates and the binding dates
      const startDatesdiff = Math.abs(moment(this.startRange).diff(eventStartDate, 'minutes'));
      const endDatesdiff = Math.abs(moment(this.endRange).diff(eventEndDate, 'minutes'));

      //trigger update date range when the date slider moved more than 5 min form the binding dates.
      if (startDatesdiff > 5 || endDatesdiff > 5) {
        this.onDateRangeChange({
          start: eventStartDate,
          end: eventEndDate
        });
      }
    });

    return stockChart;
  }

  //Generate array of chart data to be uesd by amcharts
  getStockChartDataObject(timeSeriesData = []) {
    //Dictionary to hold all dapoint values
    let valuesDict = {};

    timeSeriesData.forEach(seriesData => {
      const datapointId = seriesData.series.dataId;
      const descriptor = seriesData.series.descriptor; //Get the datapoint descriptor for this datapointId
      const datapointDisplayItem = seriesData.series.displayItem;
      const { interval: dataInterval = null } = seriesData.rollup || {};

      let map = seriesData.data.map(e => {
        const result = {};

        let value = null;
        if (angular.isObject(e.v)) {
          if (e.v.mean) {
            value = descriptor ? Math.round(e.v.mean) : e.v.mean;
          }
        } else {
          value = e.v;
        }

        //result[datapointId] = descriptor ? 1 : value;
        if (descriptor) {
          if (angular.isObject(e.v)) {
            result[datapointId] = 1;
          } else {
            result[datapointId] = e.v;
          }
        } else {
          result[datapointId] = descriptor ? 1 : value;
        }
        result[datapointId + this.VALUE_DELIMETER + 'v'] = e.v;

        const chartGraphFunctionsLines = this.defineAggregatedChartGraphs(datapointDisplayItem, seriesData.rollup);

        chartGraphFunctionsLines.forEach(agggregateFunction => {
          result[datapointId + this.VALUE_DELIMETER + agggregateFunction] = e.v[agggregateFunction];
          result[datapointId + this.VALUE_DELIMETER + agggregateFunction + '_Color'] = this.aggregatedDataColorMap[
            agggregateFunction
          ];
          if (dataInterval === null) {
            if (descriptor) {
              result[datapointId + '_Color'] = this.getDescriptiveColor(value);
            } else {
              result[datapointId + '_Color'] = this.colorArray[0];
            }
          } else {
            let color = this.getIntervalColor();
            result[datapointId + '_Color'] = color;
          }
        });

        result['t'] = e.t;
        return result;
      });

      map = _.indexBy(map, 't');
      valuesDict = _.merge(map, valuesDict);
    });
    const finalResult = _.map(valuesDict, function (e) {
      e.date = e.t;
      return e;
    });
    //Always input the min and max date values into the chart so that the top date range for the scrollbar doesn't change
    let startDateChartItem = {
      date: moment()
        .subtract(30, 'days')
        .startOf('minute')
        .toDate()
    };
    let endDateChartItem = {
      date: moment()
        .endOf('minute')
        .toDate()
    }; //Current time at init

    finalResult.push(startDateChartItem);
    finalResult.push(endDateChartItem);

    const sortedFinalResult = this.sortData(finalResult);

    return sortedFinalResult;
  }

  //Sort object by Date
  sortData(arrayData) {
    let sortedArray = arrayData.sort(function (a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    });
    return sortedArray;
  }

  capitalizeFirstletter(title) {
    const [first, ...rest] = title || '';
    return `${(first || '').toUpperCase()}${(rest || []).join('').toLowerCase()}`;
  }

  defineAggregatedChartGraphs(displayItem, seriesRollupObject) {
    const seriesAggregatedFunctions = seriesRollupObject ? seriesRollupObject.functions : [];
    //if no display item will display all returned functions
    //todo => find if we can display only mean instead of all when mean exist
    if (!displayItem) {
      return seriesAggregatedFunctions;
    }
    const displayAggergateFunction = displayItem.aggregates || [];
    //chart graphs any of returnd function that user selected in the datapoint display
    const aggergatedchartGraphFunctions = seriesAggregatedFunctions.filter(returnFunction =>
      displayAggergateFunction.includes(returnFunction)
    );
    //if chart graphs funstion still empty then will chart all return function.
    return aggergatedchartGraphFunctions.length ? aggergatedchartGraphFunctions : seriesAggregatedFunctions;
  }

  //guides function
  getSeriesDataGuide(seriesDataArray) {
    let guides = [];

    let lastRecordedValue = null;
    _.forEach(seriesDataArray, (e, index) => {
      let v = e.v;
      let lastKnownValue = null;
      if (angular.isObject(v)) {
        // used angular.isDefined(v.last) to test if defind instead (v.last) as when v.last equal 0 will return false
        if (angular.isDefined(v.last) && v.last !== null && v.last !== 'NaN') {
          lastKnownValue = {
            t: e.t,
            v: v.last
          };
        } else if (angular.isDefined(v.first) && v.first !== null && v.first !== 'NaN') {
          lastKnownValue = {
            t: e.t,
            v: v.first
          };
        }
      }

      if (lastKnownValue !== null) {
        //try adding a guide
        if (lastRecordedValue !== null) {
          guides.push({
            date: moment(lastRecordedValue.t).toDate(),
            toDate: moment(lastKnownValue.t).toDate(),
            fillColor: this.getDescriptiveColor(lastRecordedValue.v),
            fillAlpha: 1
          });
        }

        if (index === seriesDataArray.length - 1) {
          guides.push({
            date: moment(lastKnownValue.t).toDate(),
            toDate: moment(this.endRange).toDate(),
            fillColor: this.getDescriptiveColor(lastKnownValue.v),
            fillAlpha: 1
          });
        }

        lastRecordedValue = lastKnownValue;
      }
    });
    return guides;
  }

  //dont do any language translation logic on this method.
  //this method creates object we need for AmCharts javascript library
  //line chart data object as per AmStock chart
  createChartDataset(timeSeriseData = []) {
    let dataset = new AmCharts.DataSet();

    dataset['dataProvider'] = this.getStockChartDataObject(timeSeriseData); //array of object containing date and datapointvalues

    //calculate height
    let percentHeight = Math.round(100 / (timeSeriseData.length || 1));

    let fieldMappings = [];
    let panel = []; //Create the main panel

    timeSeriseData.forEach(seriesData => {
      const descriptor = seriesData.series.descriptor; //Get the datapoint descriptor for this datapointId
      const datapointDisplayItem = seriesData.series.displayItem;
      const { interval: dataInterval = null } = seriesData.rollup || {};
      let datapointId = seriesData.series.dataId;
      let title = this.getChartTitle(seriesData.series, dataInterval);

      //Panel for one datapoint
      let stockPanel = new AmCharts.StockPanel({
        fontFamily: 'Open Sans'
      });
      stockPanel.percentHeight = percentHeight;
      stockPanel.id = datapointId;
      stockPanel.title = title;

      let valueAxis = new AmCharts.ValueAxis({
        useGraphSettings: true,
        fontFamily: 'Open Sans'
      });
      //stockGraph.showBalloon = false;

      //some datapoints has descriptor but not values(numeric value) witch can be handeld in the else block
      //when value was empty the valueAxis.maximum set to 0 casing the chart not show data.
      if (descriptor && _.size(descriptor.values) > 0) {
        fieldMappings.push({
          fromField: datapointId,
          toField: datapointId
        });

        const stockGraph = new AmCharts.StockGraph({
          fontFamily: 'Open Sans'
        });
        stockGraph.valueField = datapointId;
        stockGraph.id = `${seriesData.series.id}`;

        stockGraph.balloonText = "[[date]]<br><b><span style='font-size:14px;'>[[" + datapointId + ']]</span></b>';
        stockGraph.balloonFunction = this.balloonFunction;
        stockGraph.balloonColor = this.BALLOON_COLOR;
        stockGraph.title = title;
        //We don't want datapoint descriptors to show up in the legend because its reduntant from graph title

        let legendData = [];
        if (_.size(descriptor.values) <= 6) {
          legendData = _.map(descriptor.values, (e, index) => {
            return {
              title: this.gettextCatalog.getString(e),
              color: this.getDescriptiveColor(index)
            };
          });
        }

        let legendOptions = {
          data: legendData,
          position: 'top',
          combineLegend: false,
          valueText: '[[]]',
          valueWidth: 15,
          title: title
        };

        stockPanel.addLegend(legendOptions);

        let color = datapointId + '_Color';
        stockGraph.fillColorsField = color;
        stockGraph.lineColorField = color;

        stockGraph.balloonText = "[[date]]<br><b><span style='font-size:14px;'>[[" + datapointId + ']]</span></b>';

        valueAxis.labelsEnabled = false;

        if (dataInterval === null) {
          if (datapointDisplayItem) {
            if (datapointDisplayItem.chartType === 'step') {
              stockGraph.type = 'step';
              stockGraph.lineThickness = 3;
            } else if (datapointDisplayItem.chartType === 'step_disconnected') {
              stockGraph.type = 'step';
              stockGraph.noStepRisers = true;
              stockGraph.lineThickness = 0;
            }
          }

          const numOfValues = _.size(descriptor.values);
          if (numOfValues > 0) {
            valueAxis.maximum = datapointDisplayItem.rangeMax;
            valueAxis.minimum = -1;
          }
          //stockGraph.noStepRisers = true;
          stockGraph.bullet = 'square';
          stockGraph.bulletSize = 4;
          stockGraph.bulletBorderAlpha = 0;
        } else {
          stockGraph.type = 'column';
          valueAxis.maximum = 1;
          valueAxis.minimum = 0;
          stockGraph.columnWidth = 0.2;
          stockGraph.fillAlphas = 1;
        }
        //Create the guides
        stockPanel.addStockGraph(stockGraph);
        stockPanel.guides = this.getSeriesDataGuide(seriesData.data);
      }
      //Datapoints with no descriptors
      else {
        stockPanel.stockLegend = {
          valueText: '',
          valueTextRegular: '[[]]',
          useMarkerColorForLabels: false,
          switchable: false
        };

        if (datapointDisplayItem) {
          if (angular.isDefined(datapointDisplayItem.rangeMin)) {
            valueAxis.minimum = datapointDisplayItem.rangeMin;
          }

          if (angular.isDefined(datapointDisplayItem.rangeMax)) {
            valueAxis.maximum = datapointDisplayItem.rangeMax;
          }
        }

        //For datapoints with only one graph
        if (dataInterval === null) {
          const stockGraph = new AmCharts.StockGraph({
            fontFamily: 'Open Sans'
          });
          stockGraph.valueField = datapointId;
          stockGraph.id = `${seriesData.series.id}`;

          stockGraph.balloonText = "[[date]]<br><b><span style='font-size:14px;'>[[" + datapointId + ']]</span></b>';
          stockGraph.balloonFunction = this.balloonFunction;
          stockGraph.title = this.gettextCatalog.getString('Raw');
          stockGraph.type = 'line';
          stockGraph.lineThickness = 2;
          stockGraph.bullet = 'round';
          stockGraph.bulletSize = 2;
          stockGraph.balloonColor = this.BALLOON_COLOR;
          stockGraph.color = '#000';
          stockPanel.addStockGraph(stockGraph);

          fieldMappings.push({
            fromField: datapointId,
            toField: datapointId
          });
        } else {
          const chartGraphFunctionsLines = this.defineAggregatedChartGraphs(datapointDisplayItem, seriesData.rollup);

          if (chartGraphFunctionsLines.length > 0) {
            //Create multiple graphs
            chartGraphFunctionsLines.forEach((dpdia, index) => {
              let dp = datapointId + this.VALUE_DELIMETER + dpdia;
              fieldMappings.push({
                fromField: dp,
                toField: dp
              });

              let graph = new AmCharts.StockGraph();
              graph.valueField = dp;
              graph.id = `${seriesData.series.id}${this.VALUE_DELIMETER}${dpdia}`;
              graph.useDataSetColors = false;
              graph.balloonText = "[[date]]<br><b><span style='font-size:14px;'>[[" + dp + ']]</span></b>';
              graph.balloonFunction = this.balloonFunction;

              //Only want ot show the baloon on one of the datapoints
              if (index !== 0) {
                graph.showBalloon = false;
              }

              graph.balloonFunction = this.balloonFunction;
              graph.balloonColor = this.BALLOON_COLOR;
              graph.title = this.gettextCatalog.getString(this.capitalizeFirstletter(dpdia));
              graph.color = '#ccc';
              graph.fillColorsField = '#ccc';
              graph.lineColorField = '#ccc';
              graph.type = 'line';
              graph.lineThickness = 2;
              graph.line;
              graph.bullet = 'round';
              graph.bulletSize = 2;
              stockPanel.addStockGraph(graph);
            });
          }
        }
      }

      stockPanel.addValueAxis(valueAxis);
      panel.push(stockPanel);
    });

    dataset['fieldMappings'] = fieldMappings;
    dataset['categoryField'] = 'date';

    return { dataset, panel };
  }

  //get title for datapoint
  getChartTitle(series, dataInterval) {
    const { descriptor = {} } = series;
    let chartTitle = descriptor.title || series.title;
    chartTitle = this.gettextCatalog.getString(chartTitle);

    let uom = null;

    if (series.attrs && series.attrs.uom) {
      uom = series.attrs.uom;
    }

    if (uom) {
      chartTitle += ' (' + this.gettextCatalog.getString(uom) + ')';
    }

    if (dataInterval === '1day') {
      chartTitle += ' - ' + this.gettextCatalog.getString('Daily Aggregate');
    } else if (dataInterval === '1hour') {
      chartTitle += ' - ' + this.gettextCatalog.getString('Hourly Aggregate');
    } else if (dataInterval === null) {
      //do nothing
    }
    return chartTitle;
  }

  getSeries(id) {
    const chartseriesData = (this.seriesData || []).find(serData => serData.series.id === id);
    return chartseriesData ? chartseriesData.series : {};
  }
  //for formating the balloon text label on charts
  balloonFunction(item, graph) {
    //get the datapoint id by parsing out the value field and the delimieter
    let datapointId = null;
    const [seriesId] = (graph.id || '').split(this.VALUE_DELIMETER);
    const series = this.getSeries(seriesId);
    if (graph.valueField) {
      if (graph.valueField.indexOf(this.VALUE_DELIMETER) >= 0) {
        datapointId = graph.valueField.split(this.VALUE_DELIMETER)[0];
      } else {
        datapointId = graph.valueField;
      }
    }

    let descriptor = series.descriptor; //getDescriptor(datapointId);
    let displayItem = series.displayItem; //getDatapointDisplayItem(datapointId);

    //Get the value for this datacontext
    let val = item.dataContext.dataContext[datapointId + this.VALUE_DELIMETER + 'v'];

    let innerHtml = '';

    const formatNumericValue = (val, datapointDisplayItem) => {
      if (angular.isNumber(val)) {
        let numDecimals = 2;

        if (datapointDisplayItem && datapointDisplayItem.decimals) {
          numDecimals = datapointDisplayItem.decimals || 2;
        }

        return this.$filter('number')(val, numDecimals);
      }
      return val;
    };

    const formatDescriptiveVal = (val, descriptor) => {
      if (!descriptor) {
        return val;
      }

      if (!descriptor.values) {
        return val;
      }
      if (!angular.isNumber(val)) {
        return val;
      }

      return descriptor.values[val] ? this.gettextCatalog.getString(descriptor.values[val]) : val;
    };

    if (angular.isObject(val)) {
      // use formatDescriptiveVal only if there is value discriptor values supplied
      if (!descriptor || _.size(descriptor.values) === 0) {
        //Must be a numeric?
        if ((val.mean && val.last !== 'NaN') || val.mean === 0) {
          innerHtml += `<span>${this.gettextCatalog.getString('Mean')}: ${formatNumericValue(
            val.mean,
            displayItem
          )}</span><br/>`;
        }

        if ((val.min && val.min !== 'NaN') || val.min === 0) {
          innerHtml += `<span>${this.gettextCatalog.getString('Min')}: ${formatNumericValue(
            val.min,
            displayItem
          )}</span><br/>`;
        }

        if ((val.max && val.max !== 'NaN') || val.max === 0) {
          innerHtml += `<span>${this.gettextCatalog.getString('Max')}: ${formatNumericValue(
            val.max,
            displayItem
          )}</span><br/>`;
        }
      } else {
        if (val.count) {
          if ((val.count && val.count !== 'NaN') || val.count === 0) {
            innerHtml += `<span>${this.gettextCatalog.getString('Count')}: ${val.count}</span><br/>`;
          }

          if ((val.first && val.first !== 'NaN') || val.first === 0) {
            innerHtml += `<span>${this.gettextCatalog.getString('First')}: ${formatDescriptiveVal(
              val.first,
              descriptor
            )}</span><br/>`;
          }

          if ((val.last && val.last !== 'NaN') || val.last === 0) {
            innerHtml += `<span>${this.gettextCatalog.getString('Last')}: ${formatDescriptiveVal(
              val.last,
              descriptor
            )}</span><br/>`;
          }
        }
      }
    } else {
      //some numeric datapoint can have descriptor
      if (descriptor && _.size(descriptor.values) > 0) {
        innerHtml += '<span>' + formatDescriptiveVal(val, descriptor) + '</span><br/>';
      } else {
        innerHtml += '<span>' + formatNumericValue(val, displayItem) + '</span><br/>';
      }
    }

    //Add the date....
    let html = "<br><b><span style='font-size:12px;'>" + innerHtml + '</span></b>';
    //We don't want to show the time if its an average
    let formattedDate = this.$filter('ChartLabelFilter')(item.dataContext.date, this.selectedDataInterval);

    html = formattedDate + html;

    return html;
  }
}

export default {
  template,
  controller: ChartController,
  //not useing vm as when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'chartVm',
  bindings: {
    seriesData: '<',
    loadingData: '<',
    startRange: '<',
    endRange: '<',
    minDate: '<',
    maxDate: '<',
    onDateRangeChange: '&'
  }
};
